import React from 'react'
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  makeStyles,
  Typography,
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'

const useStepStyles = makeStyles((theme) => ({
  content: {
    minHeight: 410,
  },
  title: {
    paddingBottom: theme.spacing(5),
  },
  submitButton: {
    marginLeft: theme.spacing(1),
  },
}))

export type WizardStepProps<T> = {
  children: React.ReactNode
  title: string
  isFirst: boolean
  isLast: boolean
  defaultValues?: Partial<T> // eslint-disable-line react/no-unused-prop-types
  dataCy?: string
  submitText: string
  onBack: () => void
  onSubmit: () => void
  onDelete?: () => void
}

export function WizardStep<T>({
  children,
  title,
  isFirst,
  isLast,
  dataCy,
  submitText,
  onBack,
  onSubmit,
  onDelete,
}: WizardStepProps<T>): React.ReactElement {
  const classes = useStepStyles()
  const { t } = useTranslation()

  return (
    <form onSubmit={onSubmit}>
      <DialogContent className={classes.content} data-cy={dataCy}>
        <Typography variant="h5" className={classes.title}>
          {title}
        </Typography>

        {children}
      </DialogContent>

      <DialogActions>
        <Box display="flex" flexGrow={1} justifyContent="space-between">
          <Box>
            {onDelete && (
              <Button color="secondary" onClick={onDelete}>
                {t('common.remove')}
              </Button>
            )}
          </Box>

          <Box>
            {!isFirst && (
              <Button variant="contained" onClick={onBack}>
                {t('common.previous')}
              </Button>
            )}
            <Button
              className={classes.submitButton}
              id="step-submit"
              variant="contained"
              color="primary"
              onClick={onSubmit}
            >
              {isLast ? submitText : t('common.next')}
            </Button>
          </Box>
        </Box>
      </DialogActions>
    </form>
  )
}
